import { ProductOrBrand } from "./alternativeTypes";

export const socialMediaProducts: ProductOrBrand[] = [
  {
    name: "Facebook",
    ownerCountry: "US",
    categories: ["social-media", "social-networking"],
  },
  {
    name: "X",
    ownerCountry: "US",
    categories: ["social-media", "micro-blogging"],
  },
  {
    name: "Instagram",
    ownerCountry: "US",
    categories: ["social-media", "photo-sharing"],
  },
  {
    name: "Reddit",
    ownerCountry: "US",
    categories: ["social-media", "discussion"],
  },
  {
    name: "Youtube",
    ownerCountry: "US",
    categories: ["social-media", "video-sharing"],
  },

  {
    name: "Mastodon",
    iconFile: "mastodon.png",
    ownerCountry: "FE",
    categories: ["social-media", "micro-blogging"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mastodon_(social_network)"],
  },
  {
    name: "Pixelfed",
    ownerCountry: "FE",
    categories: ["social-media", "photo-sharing"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mastodon_(social_network)"],
  },
  {
    name: "BeReal",
    ownerCountry: "FR",
    categories: ["social-media", "photo-sharing"],
    sourceLinks: ["https://en.wikipedia.org/wiki/BeReal"],
  },
  {
    name: "Bluesky",
    ownerCountry: "US",
    isLessEvilAlternative: true,
    categories: ["social-media", "micro-blogging"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Bluesky"],
  },
  {
    name: "Lemmy",
    ownerCountry: "FE",
    categories: ["social-media", "discussion"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Lemmy_(social_network)"],
  },
  {
    name: "Diaspora",
    ownerCountry: "FE",
    categories: ["social-media", "social-networking"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Diaspora_(social_network)",
      "https://diasporafoundation.org",
    ],
  },
  {
    name: "PeerTube",
    ownerCountry: "FR",
    categories: ["social-media", "video-sharing"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/PeerTube",
      "https://joinpeertube.org/",
    ],
  },
  {
    name: "Dailymotion",
    ownerCountry: "FR",
    categories: ["social-media", "video-sharing"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Dailymotion"
    ],
  },

];